import type BaseHttpService from "../../client/BaseHttpService";
import type { PaymentMethod } from "../platform/types";
import type { LegalType } from "./types";

export type PaymentMethodOption = {
	id: string;
	code: PaymentMethod;
	buttonTitle: string;
	buttonDescription?: string;
	finalizationInstructions?: string;
	title: string;
};

type CmsCollectionResponse<T> = { items: T[] };
type LegalDocRecord = { body: string };

export class CmsApi {
	constructor(private readonly http: BaseHttpService) {}

	async getLegalDoc(partnerCode: string, type: LegalType | string, language: string): Promise<string> {
		const response = await this.http.get<CmsCollectionResponse<LegalDocRecord>>(
			"Fetching legal document content from CMS",
			`/api/collections/docs/records?filter=(partner.code='${partnerCode}' %26%26 type='${type}' %26%26 language.code='${language}')`,
		);
		const [doc] = response.items;
		if (!doc) throw new Error("CMS legal document not found");
		return doc.body;
	}

	async getPaymentMethodsContent(
		partnerCode: string,
		language: string,
		allowedMethods?: PaymentMethod[],
	): Promise<PaymentMethodOption[]> {
		const response = await this.http.get<CmsCollectionResponse<PaymentMethodOption>>(
			"Fetching payment methods content from CMS",
			`/api/collections/payment_methods/records?filter=(partner.code='${partnerCode}' %26%26 language.code='${language}')`,
		);

		if (!response.items?.length) throw new Error("CMS payment methods not found");
		if (!allowedMethods?.length) return [];

		const map = new Map(response.items.map((item) => [item.code, item]));
		return allowedMethods.flatMap((code) => {
			const item = map.get(code);
			return item ? [item] : [];
		});
	}
}
